<template>
  <div>
    <div class="d-flex align-items-center p-2" style="gap: 6px;">
      <div
        v-for="index in 5"
        :key="index"
        class="rating ratingButton"
        style="cursor:pointer;"
        @click="setRatingAndOpenModal(index)"
      >
        <label v-if="index <= rating" class="selected">★</label>
        <label v-else class="unselected">☆</label>
      </div>
      <!-- <span v-if="rating > 0" class="text-muted" style="min-width:96px; display:flex; align-items:center;">({{ rating }} / 5)</span> -->
      <!-- <span v-else class="text-muted" style="min-width:96px; display:flex; align-items:center;">Rate</span> -->
    </div>

    <b-modal
      v-model="showModal"
      scrollable
      :title="title"
      size="lg"
      hide-footer
    >
      <b-container fluid>
        <b-row>
          <b-col md="12">
            <div class="iq-card p-3">
              <div class="mb-3">
                <div class="row">
                  <div class="col-sm-12 col-md-4 col-lg-4">
                    <div class="rating_label">{{ ratingFieldName }}</div>
                  </div>
                  <div class="col-sm-12 col-md-8 col-lg-8">
                    <div class="d-flex align-items-center" style="gap:6px;">
                      <div
                        v-for="index in 5"
                        :key="index"
                        class="rating ratingInput"
                        style="cursor:pointer; display: flex; align-items: center;"
                        @click="setRating(index)"
                      >
                        <label v-if="index <= rating" class="selected" style="margin: 0;">★</label>
                        <label v-else class="unselected" style="margin: 0;">☆</label>
                      </div>
                      <div class="text-muted ml-2 pb-2">( {{ rating }} / 5 )</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="mb-2 d-flex align-items-center" style="gap:10px;">
                  <b>{{ reviewFieldName }}</b>
                </div>

                <b-form-textarea
                 v-model="editorValue"
                  rows="6"
                  max-rows="12"
                  placeholder="Enter your feedback here..."
                ></b-form-textarea>
              </div>

              <div class="d-flex justify-content-end" style="gap: 10px;">
                <b-button size="sm" variant="secondary" @click="onCancel">Cancel</b-button>
                <b-button size="sm" variant="primary" @click="onSubmit">Submit</b-button>
              </div>
            </div>
          </b-col>
        </b-row>

        <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
          <div v-html="toastMsg"></div>
        </b-toast>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "ReviewsModal",
  components: {
  },
  props: {
    title: { type: String, default: "Reviews" },
    ratingFieldName: { type: String, default: "Rating" },
    reviewFieldName: { type: String, default: "Feedback" },
    reviewType: { type: String, default: "counselor" }
  },
  data () {
    return {
      showModal: false,
      rating: 0,
      editorValue: "",
      showToast: false,
      toastTitle: "Review",
      toastMsg: null,
      toastVariant: "default"
    }
  },
  methods: {
    /**
     * setRating
     */
    setRating (val) {
      this.rating = val
    },
    /**
     * setRatingAndOpenModal
     */
    setRatingAndOpenModal (val) {
      this.rating = val
      this.showModal = true
    },
    /**
     * onCancel
     */
    onCancel () {
      this.showModal = false
      this.editorValue = ""
    },
    /**
     * onSubmit
     */
    onSubmit () {
      const payload = {
        ratingPoints: this.rating,
        reviewType: this.reviewType,
        feedback: this.editorValue
      }

      if (!this.rating) {
        this.toastVariant = "danger"
        this.toastTitle = "Review"
        this.toastMsg = "Please select star rating"
        this.showToast = true
        return
      }

      // if (!this.editorValue || !String(this.editorValue).trim()) {
      //   this.toastVariant = "danger"
      //   this.toastTitle = "Review"
      //   this.toastMsg = "Please enter feedback"
      //   this.showToast = true
      //   return
      // }

      this.$emit("emitSubmitReview", payload)
      this.showModal = false
    }
  }
}
</script>

<style scoped>
.rating_label {
  font-weight: 600;
  color: #333;
}
.ratingInput {
  user-select: none;
}
.ratingButton {
  user-select: none;
  transition: transform 0.2s ease;
}
.ratingButton:hover {
  transform: scale(1.2);
}
.rating .selected {
  color: var(--iq-primary);
}
.rating .unselected {
  color: #cfcfcf;
}
.rating label {
  font-size: 22px;
  margin: 0;
  display: flex;
  align-items: center;
  line-height: 1;
}
</style>
